import { createContext } from 'react';

export const ListPanelContext = createContext<{
    target: HTMLDivElement | null;
    activate: (id: string, close: () => void) => () => void;
} | null>(null);
